export default {
    list: 'ToolBarItems',
    //child:{name:"ExportSelected"}
    DisableBaseDefaultItems:[
        {name: "Grouping"},
        {name: "Export"},
        {name:"Refresh"},
        {name:"SaveViews"}
    ],
    items: [
        {
            id:"btnUpload",
            type: "button",
            text: "Upload",
            showIcon: "toolbar",
            icon:"upload",
            attributes: { "class": " btn btn-tertiary" }
        },
        //toggle button
        {
            id:"btnDelete",
            type: "button",
            text: "Delete",
            icon:"delete",
            showIcon: "toolbar",
            attributes: { "class": " btn btn-tertiary" }
        },
        //toggle button
        {
            id:"btnReset",
            type: "button",
            text: "Reset",
            icon:"reset",
            showIcon: "toolbar",
            attributes: { "class": " btn btn-primary" }
        }
    ]
}